import { Building2, User, BadgeCheck, Briefcase } from 'lucide-react';

export const departmentSidebarItems = [
  {
    id: 1,
    label: 'Department',
    path: '/department',
    icon: Building2,
    disabled: false,
  },
  {
    id: 2,
    label: 'Designation',
    path: '/designation',
    icon: Briefcase,
    disabled: false,
  },
  {
    id: 3,
    label: 'User',
    path: '/user',
    icon: User,
    disabled: false,
  },
  {
    id: 4,
    label: 'License',
    path: '/license',
    icon: BadgeCheck,
    disabled: false,
  },
];
